































































import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import PopupHandler from '@/mixins/popupHandler'
import ModifiedDataHandler from '@/mixins/ModifiedDataHandler'
import ReadOnlyInputForIE from '@/mixins/ReadOnlyInputForIE'
import SelectDatePopup from '@/pages/issue/popup/SelectDate.vue'
import AdditionalTaxInfoPopup from '@/pages/issue/popup/AdditionalTaxInfo.vue'
import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import FooterLayout from '@/components/Footer.vue'
import FooterButton from '@/components/FooterButton.vue'
import TitleAndMessage from '@/components/TitleAndMessage.vue'
import {Form, FormItem, Input} from 'element-ui'
import {inputFormat, issueDateFormat} from '@/pages/issue/constants/issue-date-format'
import {toJSDateFormat, jsDateToFormat, getLocalTime} from '@/pages/issue/utils/date'
import {DateTime} from 'luxon'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import {namespace} from 'vuex-class'

const issue = namespace('issue')
const gtm = namespace('gtm')

@Component({
  components: {
    TitleAndMessage, SelectDatePopup, AdditionalTaxInfoPopup,
    HeaderLayout, MainLayout, FooterLayout, FooterButton,
    [Form.name]: Form, [FormItem.name]: FormItem, [Input.name]: Input,
  },
  data() {
    return {inputFormat, issueDateFormat}
  },
  methods: {toJSDateFormat, jsDateToFormat, getLocalTime},
})
export default class IssueSelectDate extends Mixins(Translation, PopupHandler, ReadOnlyInputForIE, ModifiedDataHandler) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) isConfirm: boolean

  @Ref('formRef') readonly formRef!: Form
  @Ref('dateInputRef') readonly dateInputRef!: Input

  @issue.State('writeDate') writeDate: string
  @issue.Mutation('update') update: (payload: object) => void
  @issue.Getter('gtmCommonInfo') gtmCommonInfo: object

  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  selectedDate: Date | '' = ''

  get localTime(): Date {
    return getLocalTime()
  }

  get rules(): object {
    const {ts} = this
    return {
      selectedDate: [
        {required: true, message: `${ts('transaction')}하신 날짜를 선택해주세요.`},
      ]
    }
  }

  get disabledDates(): object {
    return {
      from: this.localTime,
    }
  }

  get 오늘() {
    return DateTime.local()
  }

  get 작성일자() {
    if(!this.selectedDate) return null
    return DateTime.fromJSDate(this.selectedDate)
  }

  get 발행기한() {
    /**
     * 세금계산서 발행기한 계산
     * - 작성일자의 다음달 10일
     */
    if(!this.작성일자) return null
    return this.작성일자.plus({months: 1}).set({day: 10})
  }

  get 확정신고기한() {
    /**
     * 세금계산서 확정신고기한 계산
     * - 작성일자가 1/1 ~ 6/30 이면, 확정신고기한 = 올해 7/25
     * - 작성일자가 7/1 ~ 12/31 이면, 확정신고기한 = 다음 해 1/25
     */
    if(!this.작성일자) return null
    const 상반기 = [1, 2]
    const 하반기 = [3, 4]
    if(상반기.includes(this.작성일자.quarter)) return this.작성일자.set({month: 7, day: 25})
    if(하반기.includes(this.작성일자.quarter)) return this.작성일자.plus({years: 1}).set({month: 1, day: 25})
    return null
  }

  get 가산세유형(): '' | '1%' | '2%' {
    /**
     * 세금계산서 발급 시 발생하는 가산세 유형 계산
     */
    if(!this.오늘 || !this.발행기한 || !this.확정신고기한) return ''
    if(this.오늘 > this.발행기한 && this.오늘 > this.확정신고기한) return '2%'
    if(this.오늘 > this.발행기한 && this.오늘 <= this.확정신고기한) return '1%'
    if(this.오늘 <= this.발행기한 && this.오늘 <= this.확정신고기한) return ''
    return ''
  }

  @Watch('selectedDate', {deep: true})
  __selectedDate(value) {
    const formatValue = jsDateToFormat(value, inputFormat)
    this.modifiedData = this.diffData(this.originalData, formatValue)
  }

  mounted() {
    if(this.writeDate) {
      this.selectedDate = toJSDateFormat(this.writeDate)
      this.originalData = jsDateToFormat(this.selectedDate, inputFormat)
    } else {
      this.originalData = this.selectedDate
    }
  }

  beforeDestroy() {
    if(this.isConfirm) {
      this.logEventWithGroups({
        eventType: 'confirm_issue_date',
        eventProperties: {
          ...this.gtmCommonInfo,
          modified: this.isModifiedData,
        }
      })
    }
  }

  onSelectedDate(date) {
    this.selectedDate = date
  }

  onClickDone() {
    this.formRef.validate((valid) => {
      if(valid) {
        this.update({writeDate: jsDateToFormat(this.selectedDate, issueDateFormat)})
        this.$emit('action', 'ok')
        if(!this.isConfirm) {
          this.logEventWithGroups({
            eventType: 'input_issue_date',
            eventProperties: {
              'workflow': 'issue_invoice',
            }
          })
        }
      }
    })
  }

  onClickBackward() {
    if(this.isModifiedData) {
      const {message, options} = this.confirmMessageOptions
      this.$confirm(message, options)
        .then(() => {
          this.selectedDate = toJSDateFormat(this.writeDate)
        })
        .then(() => {
          this.$emit('action', 'back')
        })
        .catch((e) => e)
    } else {
      this.$emit('action', 'back')
    }
  }

  onClickIssuedList() {
    this.$router.push({name: 'issued-invoices'}).catch((e) => e)
  }
}
